import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Routes from 'lib/utils/routes';
import { getMachine } from 'lib/selectors/getMachine';
import { getIsApmERPJobFlow } from 'lib/selectors/getIsApmERPJobFlow';
import PrimaryButton from 'components/Button/PrimaryButton';
import { useHistory } from 'react-router-dom';

/**
 * AssignJob Component
 *
 * Displays the current shift status of a machine, indicating whether:
 * - The machine is not in a shift schedule
 * - The machine is in an unattended shift
 * - The machine is in an attended shift (shows empty container)
 *
 * @component
 * @returns {JSX.Element} The rendered shift indicator component
 *
 * @example
 * return (
 *   <AssignJob />
 * )
 */
const AssignJob = () => {
  const { t } = useTranslation();

  const machine = useSelector(getMachine);
  const isApmERPJobFlow = useSelector(getIsApmERPJobFlow);
  const history = useHistory();

  // Case 3: Machine is in an attended shift (no indicator needed)
  return (
    <PrimaryButton
      variant="primary"
      onClick={() => {
        if (isApmERPJobFlow) {
          window.dispatchEvent(new CustomEvent('apm:open-apm-select-jobs'));
        } else {
          history.push(Routes.machineIdSelectJobPath(machine.id));
        }
      }}
    >
      {t('Assign unknown job')}
    </PrimaryButton>
  );
};

export default AssignJob;
